import "./App.css";
import {I18nextProvider} from "react-i18next";

import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import AdminPanel from "./components/AdminPanel";

import ClientOffice from "./components/ClientOffice";
import LoginPage from "./components/LoginPage";
import ProtectedRoute from "./components/routing/ProtectedRoute";
import TopBar from "./components/TopBar";
import AddAdmin from "./components/user_components/AddAdmin";
import {AuthProvider} from "./context/AuthContext";
import i18n from "./i18n";

function App() {
	return (
		<div className="App">
			<I18nextProvider i18n={i18n}>
				<Router>
					<AuthProvider>
						<div>
							<TopBar/>
							{/* A <Switch> looks through its children <Route>s and
                    renders the first one that matches the current URL. */}
							<Routes>
								<Route path="/*" element={
									<ProtectedRoute>
										<AdminPanel/>
									</ProtectedRoute>
								}/>
								<Route path="app/login/" element={
									<ProtectedRoute>
										<LoginPage/>
									</ProtectedRoute>
								}/>
								<Route path="acps/*" element={
									<ProtectedRoute>
										<ClientOffice/>
									</ProtectedRoute>
								}/>
								<Route path="add-admin" element={
									<AddAdmin/>
								}/>
							</Routes>
						</div>

					</AuthProvider>
				</Router>
			</I18nextProvider>
		</div>
	);
}

export default App;
